import { render } from "./AdminLibraryMusic.vue?vue&type=template&id=017a4040&scoped=true&ts=true"
import script from "./AdminLibraryMusic.vue?vue&type=script&lang=ts"
export * from "./AdminLibraryMusic.vue?vue&type=script&lang=ts"

import "./AdminLibraryMusic.vue?vue&type=style&index=0&id=017a4040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017a4040"]])

export default __exports__